// extracted by mini-css-extract-plugin
export default {"container":"Studies_container__GdM-r","cartagene":"Studies_cartagene__v9huJ","logo":"Studies_logo__a90rv"};